"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
}), Object.defineProperty(exports, "AuthenticationFailureError", {
    enumerable: !0,
    get: function() {
        return AuthenticationFailureError;
    }
});
class AuthenticationFailureError extends Error {
    constructor(message){
        super(message);
    }
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9odHRwL2F1dGgvQXV0aGVudGljYXRpb25GYWlsdXJlRXJyb3IudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNsYXNzIEF1dGhlbnRpY2F0aW9uRmFpbHVyZUVycm9yIGV4dGVuZHMgRXJyb3Ige1xuICAgIGNvbnN0cnVjdG9yKG1lc3NhZ2U6IHN0cmluZykge1xuICAgICAgICBzdXBlcihtZXNzYWdlKVxuICAgIH1cbn1cbiJdLCJuYW1lcyI6WyJBdXRoZW50aWNhdGlvbkZhaWx1cmVFcnJvciIsIkVycm9yIiwiY29uc3RydWN0b3IiLCJtZXNzYWdlIl0sIm1hcHBpbmdzIjoiOzs7bUNBQWFBOzs7ZUFBQUE7OztBQUFOLE1BQU1BLG1DQUFtQ0M7SUFDNUNDLFlBQVlDLE9BQWUsQ0FBRTtRQUN6QixLQUFLLENBQUNBO0lBQ1Y7QUFDSiJ9